import { Page } from "@/models/page-models/Page";

export const RmTransfer: Page = {
  "path": "rm-transfer",
  "name": "RM Transfer",
  "props": {
    "data": {
      "title": "RM Transfer",
      "printable": "FALSE",
      "url": "rm-transfer",
      "groups": [
        {
          "type": "popupGroup",
          "label": "Request Goods Transfer",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.locationFrom",
                  "label": "Select Location From",
                  "disabled": "FALSE",
                  "items": "fetchedData.location.locations",
                  "itemText": "_key",
                  "itemValue": "_key"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.locationTo",
                  "label": "Select Location To",
                  "disabled": "FALSE",
                  "items": "fetchedData.location.locations",
                  "itemText": "_key",
                  "itemValue": "_key"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.quantity",
                  "label": "Enter Quantity",
                  "unit": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedGood.rawMaterialUnit}},'),==,'SQM'),SQM,KG)",
                  "disabled": "FALSE",
                  "inputType": "convert",
                  "enableConvertFnFlag": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedGood.rawMaterialUnit}},'),==,'SQM')",
                  "convertFn": "sqmToKg",
                  "goodsId": "{{formData.rawMaterial}}"
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Submit",
              "onClick": [
                {
                  "executionOrder": 1,
                  "name": "submitGoodsTransferRequest"
                },
                {
                  "executionOrder": 2,
                  "name": "closeRequestsGoodsPopup"
                }
              ]
            }
          ]
        },
        {
          "type": "tabs",
          "tabItems": [
            {
              "tabName": "RM",
              "bracketValueFormula": "fn(LENGTH,{{fetchedData.RMs.data}})",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "variable": "formData.rmTable",
                      "label": "RM",
                      "disabled": "FALSE",
                      "items": "fetchedData.RMs.data",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "Good#"
                        },
                        {
                          "value": "__item.details",
                          "text": "Good Details",
                          "formula": "fn(HELPER_FN,goodsName,{{__item}})",
                          "variableType": "item"
                        },
                        {
                          "value": "__item.location.Factory.totalQuantity",
                          "text": "Floor Quantity",
                          "type": "formula",
                          "filterType": "unit",
                          "formula": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{__item.rawMaterialUnit}},'),==,'SQM'),{{fn(STANDARD_FUNCTIONS,kgToSQM,{{__item.location.Factory.totalQuantity}},{{__item}})}},{{__item.location.Factory.totalQuantity}})",
                          "filterParam": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{__item.rawMaterialUnit}},'),==,'SQM'),SQM,KG)",
                          "variableType": "item"
                        },
                        {
                          "value": "__item.updatedAt",
                          "text": "Date Modified",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        },
                        {
                          "value": "__item.actions",
                          "text": "Actions",
                          "type": "actions",
                          "width": 225,
                          "actions": [
                            {
                              "label": "Request Transfer",
                              "onClick": [
                                {
                                  "executionOrder": 1,
                                  "name": "copyMaterialId"
                                },
                                {
                                  "executionOrder": 1,
                                  "name": "copySelectedGoodsObject"
                                },
                                {
                                  "executionOrder": 2,
                                  "name": "copyLocationData"
                                },
                                {
                                  "executionOrder": 3,
                                  "name": "getTransformedLocationsArray"
                                },
                                {
                                  "executionOrder": 4,
                                  "name": "openRequestsGoodsPopup"
                                }
                              ]
                            }
                          ],
                          "useMenu": false
                        }
                      ],
                      "tableType": "static",
                      "showActions": true,
                      "height": "73vh"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "name": "getRMs"
      }
    ],
    "functions": [
      {
        "name": "getRMs",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/goods/RM?location=Warehouse",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.RMs",
        "arg3Key": "addToState",
        "arg3Value": "{\"actionName\":\"addMultipleGoods\",\"variable\":\"fetchedData.RMs.data\"}"
      },
      {
        "name": "copyFGId",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__item._id",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.rawMaterial"
      },
      {
        "name": "copyMaterialId",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__item._id",
        "arg2Key": "destinationKey",
        "arg2Value": "formData.rawMaterial"
      },
      {
        "name": "copyLocationData",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__item.location",
        "arg2Key": "sourceFn",
        "arg2Value": "getLocationsArray",
        "arg3Key": "destinationKey",
        "arg3Value": "fetchedData.location"
      },
      {
        "name": "getLocationsArray",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "locations": "fn(TO_ARRAY,{{__selectedObject}})"
        },
        "useFormula": true
      },
      {
        "name": "copySelectedGoodsObject",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__item",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.selectedGood"
      },
      {
        "name": "openRequestsGoodsPopup",
        "type": "fnOpenPopup",
        "arg1Key": "popupName",
        "arg1Value": "Request Goods Transfer"
      },
      {
        "name": "closeRequestsGoodsPopup",
        "type": "fnClosePopup",
        "arg1Key": "popupName",
        "arg1Value": "Request Goods Transfer"
      },
      {
        "name": "openFGTransferPopup",
        "type": "fnOpenPopup",
        "arg1Key": "popupName",
        "arg1Value": "Request FG Transfer"
      },
      {
        "name": "closeFGTransferPopup",
        "type": "fnClosePopup",
        "arg1Key": "popupName",
        "arg1Value": "Request FG Transfer"
      },
      {
        "name": "submitGoodsTransferRequest",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/goods/transfer/request",
        "arg2Key": "postData",
        "arg2Value": "formData",
        "arg3Key": "refreshPage",
        "arg3Value": "TRUE"
      },
      {
        "name": "openFactoryTicket",
        "type": "fnRedirect",
        "arg1Key": "redirectUrl",
        "arg1Value": "/factory-ticket/{{__item.factoryTicket._id}}"
      },
      {
        "name": "resetFgQuantity",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.quantity"
      }
    ]
  },
  "forRole": "PRODUCTION_MANAGER,PRODUCTION_PLANNER",
  "visible": true,
  "routerPriority": 75
}